// extracted by mini-css-extract-plugin
export default {"Wrapper":"NotificationTableRow_Wrapper__F1Mw0"};